import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "聚焦体系",
    desc: "始终围绕医术修炼体系展开，炼丹、针灸、功法的设定与脉络是本站的核心内容。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "忠于原著",
    desc: "所有解读都建立在漫画原作设定的基础上，不虚构剧情与能力，帮助读者准确理解作品。",
  },
  {
    icon: "ri-layout-grid-line",
    title: "结构清晰",
    desc: "用总览、分类、专题的形式组织内容，让新老读者都能快速找到想看的体系信息。",
  },
  {
    icon: "ri-lightbulb-flash-line",
    title: "持续更新",
    desc: "随着漫画剧情推进，不断补充新的境界、丹药与功法解读，保持内容的新鲜与完整。",
  },
];

export default function About() {
  return (
    <>
      <Navbar />
      <BackToTop />

      <section className="bg-primary-700 pt-24 pb-12 md:pt-28 md:pb-16">
        <div className="container-site">
          <nav aria-label="面包屑" className="text-xs text-primary-300">
            <ol className="flex flex-wrap items-center gap-1.5">
              <li><Link to="/" className="hover:text-background-50">首页</Link></li>
              <li aria-hidden="true"><i className="ri-arrow-right-s-line"></i></li>
              <li aria-current="page" className="text-accent-300">关于我们</li>
            </ol>
          </nav>
          <h1 className="mt-4 text-2xl font-bold text-background-50 md:text-4xl">关于我们</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-primary-100 md:text-base">
            一个专注梳理《天才医仙漫画》医术修炼体系的中文内容站。
          </p>
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-16">
        <div className="container-site grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="text-sm font-medium uppercase tracking-wider text-primary-600">品牌介绍</p>
            <h2 className="mt-2 text-2xl font-bold md:text-3xl">把"医仙之路"讲清楚</h2>
            <p className="mt-4 text-[15px] leading-8 text-foreground-700">
              《天才医仙漫画》以医术修炼为内核，炼丹、针灸、功法的设定既精妙又有一定门槛。本站成立的初衷，就是把这套体系拆解成新老读者都能快速消化的内容——从三大体系的关系，到六大境界的升级顺序，再到丹药与药园的对应逻辑。
            </p>
            <p className="mt-4 text-[15px] leading-8 text-foreground-700">
              我们希望这里成为追更读者"看漫画前后都会来逛一逛"的知识角落：想知道主角如何一步步变强，来这里查脉络；想深入考据某个设定，来这里翻专题。
            </p>
          </div>
          <div className="relative h-64 w-full overflow-hidden rounded-lg md:h-80">
            <img
              src="https://readdy.ai/api/search-image?query=%E5%8F%A4%E9%A3%8E%E7%94%B7%E5%AD%90%E5%92%8C%E8%8D%AF%E8%8D%89%E7%BC%96%E5%86%99%E5%8D%B7%E8%BD%B4%20%E4%B8%B9%E7%82%89%E9%93%B6%E9%92%88%E5%8F%A4%E7%B1%8D%20%E5%9B%BD%E7%94%BB%E6%B0%B4%E5%A2%A8%E9%A3%8E%E6%85%A2%E7%94%BB%E9%A3%8E%20%E6%9A%96%E9%87%91%E4%B8%8E%E7%8E%89%E9%9D%92%E7%BB%BF%E6%9A%96%E8%89%B2%E8%B0%83&width=960&height=720&seq=about-tiancai-01&orientation=landscape"
              alt="天才医仙漫画修炼体系站的书卷与医道古风配图"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-12 md:py-16">
        <div className="container-site grid gap-10 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200/80 bg-background-50 p-6 md:p-8">
            <p className="text-sm font-medium uppercase tracking-wider text-primary-600">网站定位</p>
            <h2 className="mt-2 text-xl font-bold md:text-2xl">内容第一，做深度而非热度</h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              我们不追标题党，也不堆砌无营养的简介。每一篇专题都围绕具体的体系设定展开，力求让读者读完就能真正理解作品、看懂情节。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              我们坚持"结构清晰"的内容组织：总览给出全景，分类深入流派，专题拆解细节，三条线相互配合，无论你是刚入坑还是老读者，都能各取所需。
            </p>
          </div>
          <div className="rounded-lg border border-background-200/80 bg-background-50 p-6 md:p-8">
            <p className="text-sm font-medium uppercase tracking-wider text-primary-600">发展理念</p>
            <h2 className="mt-2 text-xl font-bold md:text-2xl">与读者一起成长</h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              漫画的医仙之路很长，我们愿意陪读者一起走下去。随着剧情推进，我们会持续补充新境界、新丹药、新功法与医道传承的解读，让这份"修炼地图"始终完整可用。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              如果你发现某个设定需要补充或想看到特定专题，欢迎通过页面底部的联系方式告诉我们，你的建议会让这里变得更好。
            </p>
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-16">
        <div className="container-site">
          <div className="max-w-2xl">
            <p className="text-sm font-medium uppercase tracking-wider text-primary-600">内容原则</p>
            <h2 className="mt-2 text-2xl font-bold md:text-3xl">我们如何做内容</h2>
          </div>
          <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((p) => (
              <div key={p.title} className="rounded-lg border border-background-200/80 bg-background-100/60 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-12 md:py-16">
        <div className="container-site">
          <p className="text-sm font-medium uppercase tracking-wider text-primary-600">联系我们</p>
          <h2 className="mt-2 text-2xl font-bold md:text-3xl">有问题或建议？</h2>
          <div className="mt-8 grid gap-6 md:grid-cols-3">
            <div className="flex items-start gap-4 rounded-lg border border-background-200/80 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-mail-line text-xl" aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold">邮箱</h3>
                <a href="mailto:hello@tiancaiyixian.com" className="mt-1 block text-sm text-primary-700 hover:text-primary-800">
                  hello@tiancaiyixian.com
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4 rounded-lg border border-background-200/80 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-chat-3-line text-xl" aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold">反馈</h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">欢迎反馈你想看的体系专题或设定补充。</p>
              </div>
            </div>
            <div className="flex items-start gap-4 rounded-lg border border-background-200/80 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className="ri-map-pin-line text-xl" aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold">定位</h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">中文在线阅读与考据型内容站点。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}